import { render, staticRenderFns } from "./RadarTemplateFormModal.vue?vue&type=template&id=0c478936"
import script from "./RadarTemplateFormModal.vue?vue&type=script&lang=js"
export * from "./RadarTemplateFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports